/** Normalize a source entry from API Pascal-case to internal camel-case */
export function normalizeSource(src) {
    return {
        id: src.Id,
        rawId: src.Id,
        title: src.Title,
        text1: src.Text1 ? { id: src.Text1.Id, name: src.Text1.Name, words: src.Text1.Words ?? null } : { id: null, name: "?", words: null },
        text2: src.Text2 ? { id: src.Text2.Id, name: src.Text2.Name, words: src.Text2.Words ?? null } : { id: null, name: "?", words: null },
        // Zero-match padding pairs (includeAll=true, no authsnap) have Id=null → treat as no match
        percent: src.Id === null ? null : src.Percent,
        percent2: src.Id === null ? null : (src.Percent2 ?? src.Percent),
        mw: src.Id === null ? 0 : (src.MW ?? 0),
    };
}

/** Build sorted list of unique text nodes from collusion source pairs */
export function buildTextList(sources) {
    const map = new Map();
    sources.forEach(({ text1, text2 }) => {
        if (!map.has(text1.id)) map.set(text1.id, { name: text1.name, words: text1.words });
        if (!map.has(text2.id)) map.set(text2.id, { name: text2.name, words: text2.words });
    });
    return Array.from(map.entries())
        .sort((a, b) => a[1].name.localeCompare(b[1].name))
        .map(([id, { name, words }]) => ({ id, name, words }));
}

/** Build NxN similarity matrix (percent or null on diagonal) */
export function buildMatrix(texts, sources) {
    const idxOf = new Map(texts.map((t, i) => [t.id, i]));
    const n = texts.length;
    const matrix = Array.from({ length: n }, () => Array(n).fill(null));
    sources.forEach(({ text1, text2, percent, percent2, mw }) => {
        if (percent === null) return;
        // text1 → column (diagonal top labels), text2 → row (right labels)
        const c = idxOf.get(text1.id);
        const r = idxOf.get(text2.id);
        if (r != null && c != null) {
            // p2 = column (text1) %, p1 = row (text2) % — keeps tooltip: texts[c]/p2 and texts[r]/p1
            matrix[r][c] = { p1: percent2, p2: percent, mw };
            matrix[c][r] = { p1: percent, p2: percent2, mw };
        }
    });
    return matrix;
}

/** HSL colour: green (0%) → yellow (50%) → red (100%) */
export function percentColor(pct) {
    if (pct === null) return "#f0f0f0";
    const h = Math.round(120 - pct * 1.2);
    return `hsl(${h}, 75%, 50%)`;
}

/** Count distinct texts that share at least one match */
export function relatedTextCount(sources) {
    const ids = new Set();
    sources.forEach(({ text1, text2 }) => { ids.add(text1.id); ids.add(text2.id); });
    return ids.size;
}
